import React from 'react';
import { advantages } from '../../data/mock';
import { Building2, Clock, UserCheck, Shield, Percent, Award } from 'lucide-react';

const iconMap = {
  Building2,
  Clock,
  UserCheck,
  Shield,
  Percent,
  Award
};

const Advantages = () => {
  return (
    <section className="py-12 lg:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-10 lg:mb-16">
          <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider">Ihre Vorteile</span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-3 mb-4">
            Warum über 10.000 Kunden uns vertrauen
          </h2>
          <p className="text-slate-600">
            Profitieren Sie von unserer langjährigen Erfahrung und unserem umfangreichen Netzwerk an Partnerbanken.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {advantages.map((advantage, index) => {
            const IconComponent = iconMap[advantage.icon];
            return (
              <div
                key={advantage.id}
                className="group p-6 bg-slate-50 rounded-2xl hover:bg-white hover:shadow-xl border border-transparent hover:border-slate-100 transition-all duration-300"
              >
                <div className="w-14 h-14 bg-blue-100 group-hover:bg-blue-600 rounded-xl flex items-center justify-center mb-5 transition-colors duration-300">
                  {IconComponent && (
                    <IconComponent className="w-7 h-7 text-blue-600 group-hover:text-white transition-colors duration-300" />
                  )}
                </div>
                <h3 className="text-xl font-semibold text-slate-900 mb-3">
                  {advantage.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {advantage.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Advantages;
